import React from "react";

const SvgComponent = props => (
  <svg width={43.275} height={36.589} viewBox="0 0 43.275 36.589" {...props}>
    <g fill="#83a5b3">
      <path d="M32.887 31.425a1.496 1.496 0 000-2.992H5.111a1.495 1.495 0 100 2.992h27.776zM38.428 36.634a1.496 1.496 0 000-2.992H10.65c-.826 0-1.498.67-1.498 1.496s.672 1.496 1.498 1.496h27.778zM35.715 25.478a7.56 7.56 0 007.562-7.561s.039-7.552-7.908-7.552C33.649 3.29 27.03 2.931 25.173 3.43c-2.014-2.004-5.366-3.476-8.756-3.476-6.721 0-12.229 5.197-12.727 11.792a7.354 7.354 0 003.664 13.731l28.361.001zM7.99 22.662c-2.748 0-4.773-1.988-4.773-4.561 0-2.101 1.334-3.943 3.418-4.572.25-9.929 8.97-10.436 9.939-10.436 2.883 0 5.74 1.413 7.582 3.505 3.717-1.222 8.814 1.646 8.244 7.19 1.451-.588 2.906-.541 3.32-.541 2.084 0 4.602 1.822 4.602 4.813a4.602 4.602 0 01-4.602 4.602H7.99z" />
    </g>
  </svg>
);

export default __webpack_public_path__ + "static/media/50d.f1aae715.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/50d.svg